import * as url from "../helpers/url_helper"

const PageTitle = {
    MERCHANT_GROUP_LIST: "Merchant Groups",
    MERCHANT_GROUP_DETAIL: "Merchant Group",
    MERCHANT_GROUP_ADD: "Add Merchant Group",
    MERCHANT_DETAIL: "Merchant",
    MERCHANT_ADD: "Add Merchant",
    BRAND_DETAIL: "Brand",
    BRAND_LIST: "Brands",
    MERCHANT_LIST: "Merchants",
    CURATOR_OFFERS_LIST: "Curator Offers",
    CURATOR_OFFERS_DETAIL: "Curator Offer",
    CURATOR_OFFERS_ADD: "Add Offer",
    OPERATION_OFFERS_LIST: "Operation Offers",
    OPERATION_OFFERS_DETAIL: "Operation Offer",
    OPERATION_OFFERS_ADD: "Add Offer",
    APPROVER_OFFERS_LIST: "Approver Offers",
    APPROVER_OFFERS_DETAIL: "Approver Offer",
    PUBLISHED_OFFERS_LIST: "Published Offers",
    PUBLISHED_OFFERS_DETAIL: "Published Offer",
    USER_LIST: "Users",
    USER_DETAIL: "User",
    USER_ADD: "Add User",
}

const PageTabs = {
    MERCHANT_GROUP_DETAIL: {
        tabs: [
            {
                name: "Merchant Group",
                add: { contextUri: url.MANAGE_MERCHANT_GROUP, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_GROUP, actionType: "get" }
            },
            {
                name: "Communications",
                add: { contextUri: url.MANAGE_MERCHANT_GROUP_COMMUNICATION, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_GROUP_COMMUNICATIONS, actionType: "get" }
            },
            {
                name: "Contacts",
                add: { contextUri: url.MANAGE_MERCHANT_GROUP_CONTACT, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_GROUP_CONTACTS, actionType: "get" }
            },
            {
                name: "Bankings",
                add: { contextUri: url.MANAGE_MERCHANT_GROUP_BANKING, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_GROUP_BANKING, actionType: "get" }
            },
            {
                name: "Admin User",
                add: { contextUri: url.CREATE_MERCHANT_GROUP_ADMIN, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_GROUP_ADMIN, actionType: "get" }
            },
        ]
    },
    MERCHANT_DETAIL: {
        tabs: [
            {
                name: "Merchant",
                add: { contextUri: url.MANAGE_MERCHANT, actionType: "post" },
                get: { contextUri: url.GET_MERCHANTS, actionType: "get" }
            },
            {
                name: "Communications",
                add: { contextUri: url.MANAGE_MERCHANT_COMMUNICATION, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_COMMUNICATIONS, actionType: "get" }
            },
            {
                name: "Contacts",
                add: { contextUri: url.MANAGE_MERCHANT_CONTACT, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_CONTACTS, actionType: "get" }
            },
            {
                name: "Timings",
                add: { contextUri: url.MANAGE_MERCHANT_TIMING, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_TIMINGS, actionType: "get" }
            },
            {
                name: "Tags",
                add: { contextUri: url.MANAGE_MERCHANT_TAG, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_TAGS, actionType: "get" }
            },
            {
                name: "Images",
                add: { contextUri: url.MANAGE_MERCHANT_IMAGE, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_IMAGES, actionType: "get" }
            },
            {
                name: "Attributes",
                add: { contextUri: url.MANAGE_MERCHANT_ATTRIBUTE, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_ATTRIBUTES, actionType: "get" }
            },
            {
                name: "Variables",
                add: { contextUri: url.CREATE_MERCHANT_VARIABLES, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_VARIABLES, actionType: "get" }
            },
            {
                name: "Merchant PINs",
                add: { contextUri: url.UPDATE_MERCHANT_PINS, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_PINS, actionType: "get" }
            },
            {
                name: "Bankings",
                add: { contextUri: url.MANAGE_MERCHANT_BANKING, actionType: "post" },
                get: { contextUri: url.GET_MERCHANT_BANKING, actionType: "get" }
            }
        ]
    },
    BRAND_DETAIL: {
        tabs: [
            {
                name: "Brand",
                add: { contextUri: url.MANAGE_BRAND, actionType: "post" },
                get: { contextUri: url.GET_BRANDS, actionType: "get" }
            }
        ],
    },
    CURATOR_OFFERS_DETAIL: {
        tabs: [
            {
                name: "Offer",
                add: { contextUri: url.MANAGE_CURATOR_OFFER, actionType: "post" },
                get: { contextUri: url.GET_CURATOR_OFFERS, actionType: "get" }
            },
            {
                name: "Tags",
                add: { contextUri: url.MANAGE_OFFER_TAGS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_TAGS, actionType: "get" }
            },
            {
                name: "Inclusions",
                add: { contextUri: url.MANAGE_OFFER_INCLUSIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_INCLUSIONS, actionType: "get" }
            },
            {
                name: "Exclusions",
                add: { contextUri: url.MANAGE_OFFER_EXCLUSIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_EXCLUSIONS, actionType: "get" }
            },
            {
                name: "Terms & Conditions",
                add: { contextUri: url.MANAGE_OFFER_TERMS_CONDITIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_TERMS_CONDITIONS, actionType: "get" }
            }
        ]
    },
    OPERATION_OFFERS_DETAIL: {
        tabs: [
            {
                name: "Offer",
                add: { contextUri: url.MANAGE_OPERATIONS_OFFER, actionType: "post" },
                get: { contextUri: url.GET_OPERATION_OFFERS, actionType: "get" }
            },
            {
                name: "Tags",
                add: { contextUri: url.MANAGE_OFFER_TAGS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_TAGS, actionType: "get" }
            },
            {
                name: "Inclusions",
                add: { contextUri: url.MANAGE_OFFER_INCLUSIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_INCLUSIONS, actionType: "get" }
            },
            {
                name: "Exclusions",
                add: { contextUri: url.MANAGE_OFFER_EXCLUSIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_EXCLUSIONS, actionType: "get" }
            },
            {
                name: "Terms & Conditions",
                add: { contextUri: url.MANAGE_OFFER_TERMS_CONDITIONS, actionType: "post" },
                get: { contextUri: url.GET_OFFER_TERMS_CONDITIONS, actionType: "get" }
            }
        ]
    },
    APPROVER_OFFERS_DETAIL: {
        tabs: [
            {
                name: "Offer",
                get: { contextUri: url.GET_APPROVER_OFFERS, actionType: "get" }
            },
            {
                name: "Tags",
                get: { contextUri: url.GET_OFFER_TAGS, actionType: "get" }
            },
            {
                name: "Inclusions",
                get: { contextUri: url.GET_OFFER_INCLUSIONS, actionType: "get" }
            },
            {
                name: "Exclusions",
                get: { contextUri: url.GET_OFFER_EXCLUSIONS, actionType: "get" }
            },
            {
                name: "Terms & Conditions",
                get: { contextUri: url.GET_OFFER_TERMS_CONDITIONS, actionType: "get" }
            }
        ]
    },
    PUBLISHED_OFFERS_DETAIL: {
        tabs: [
            {
                name: "Offer",
                get: { contextUri: url.GET_PUBLISHED_OFFERS, actionType: "get" }
            },
            {
                name: "Tags",
                get: { contextUri: url.GET_OFFER_TAGS, actionType: "get" }
            },
            {
                name: "Inclusions",
                get: { contextUri: url.GET_OFFER_INCLUSIONS, actionType: "get" }
            },
            {
                name: "Exclusions",
                get: { contextUri: url.GET_OFFER_EXCLUSIONS, actionType: "get" }
            },
            {
                name: "Terms & Conditions",
                get: { contextUri: url.GET_OFFER_TERMS_CONDITIONS, actionType: "get" }
            }
        ]
    },
    USER_DETAIL: {
        tabs: [
            {
                name: "User",
                add: { contextUri: url.MANAGE_USER, actionType: "post" },
                get: { contextUri: url.GET_USERS, actionType: "get" }
            }
        ]
    },
}

export { PageTabs, PageTitle }
